import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { useCurrencies } from '../../hooks';
import type { Currency, CurrencyFilters } from '../../models';

export interface CurrencyFieldProps extends Omit<SelectProps<Currency>, 'options'> {
  defaultFilters?: Partial<CurrencyFilters & { searchParams: { ids: string[] } }>;
  label?: string;
  errorMessage?: SelectFieldProps<Currency>['errorMessage'];
  isInvalid?: boolean;
}

export const CurrencyField: React.FC<CurrencyFieldProps> = ({ defaultFilters, label, ...otherFieldProps }) => {
  const { data, isLoading, updateFilters } = useCurrencies(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { currencyName: search } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { currencyName: search } })}
      isLoading={isLoading}
    />
  );
};
